import React, { useCallback, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Button, Label, SimpleTimer } from '@atlas/ui';

import { bonusStatuses } from 'common/constants';
import CountdownTimer from 'common/CountdownTimer/CountdownTimer';
import { capitalize } from 'common/utils/capitalize';

const { ACTIVATED, CANCELED, COMPLETED, DISABLED, EXPIRED, IN_PROGRESS, PENDING, SPEND } =
  bonusStatuses;

export const RenderBonusStatus = ({ children, isBonusSubInfo, status }) => (
  <>
    <div className="product-label">
      <span className="sub-title-text">
        <Label message="status" />:
      </span>
      <Label className={cx('title-small-text', status && status)} message={capitalize(status)} />
    </div>
    <div className="profile-bonus-activated">
      {isBonusSubInfo && (
        <Label
          className="profile-bonus-activated__text"
          message="Before the bonus is deactivated there are"
        />
      )}
      {children}
    </div>
  </>
);

const BonusStatus = ({ activateBonus, bonus }) => {
  const now = Date.now();
  const [isLoading, setIsLoading] = useState(false);

  const { createTime, expirationTime, status, timeToWager, wagerStartTime } = bonus;

  const activateBonusHandler = useCallback(async () => {
    setIsLoading(true);
    await activateBonus(bonus).then(() => {
      setIsLoading(false);
    });
  }, [bonus, activateBonus]);

  switch (status) {
    case PENDING:
    case CANCELED:
    case COMPLETED:
    case DISABLED:
    case EXPIRED:
    case SPEND:
      return <RenderBonusStatus status={status} />;

    case ACTIVATED:
      return (
        <RenderBonusStatus isBonusSubInfo status={status}>
          <div className="activated-bonus">
            <SimpleTimer time={3 * 24 * 60 * 60 * 1000 + createTime} />
          </div>
        </RenderBonusStatus>
      );

    case IN_PROGRESS:
      return (
        <RenderBonusStatus isBonusSubInfo status={status}>
          <div className="activated-bonus">
            <SimpleTimer time={wagerStartTime + timeToWager} />
          </div>
        </RenderBonusStatus>
      );

    default:
      return (
        <div className="activated-container">
          <Button
            className={(expirationTime && 'btn-bonus-timer block') || 'block'}
            disabled={isLoading}
            label={expirationTime ? 'bonus_timer_activate_button' : 'bonus_activate_button'}
            loading={isLoading}
            onClick={activateBonusHandler}
            size="medium"
            type="primary"
          >
            {expirationTime && (
              <div className="btn-bonus-timer-wrap">
                (
                <CountdownTimer time={expirationTime - now} />)
              </div>
            )}
          </Button>
        </div>
      );
  }
};

BonusStatus.propTypes = {
  activateBonus: PropTypes.func.isRequired,
  bonus: PropTypes.object.isRequired,
};

export default BonusStatus;
